export const SET_STAFF_MEMBER = 'SET_STAFF_MEMBER'
export const RESET_STAFF_MEMBER = 'RESET_STAFF_MEMBER'
